import dayjs from 'dayjs'

export const DATE_FORMAT = {
  DATE_PICKER: 'DD/MM/YYYY',
  DEFAULT: 'DD MMM, YYYY',
  WITH_TIME: 'HH:mm, DD MMM, YYYY',
} as const

export const formatDate = (date: Date, format: string): string => dayjs(date).format(format)
